<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown
    @click="onClickNotificationBell"
    class="cursor-pointer" vs-custom-content vs-trigger-click>
    <feather-icon v-if="newNotificationCounter > 0" :badge="newNotificationCounter"
      class="notification-bell cursor-pointer mt-1 sm:mr-6 mr-2" icon="BellIcon"
      svgClasses="text-danger"
    />
    <feather-icon v-else
      class="cursor-pointer mt-1 sm:mr-6 mr-2 text-grey" icon="BellIcon"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown bg-white"
    >

      <!-- <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white" v-if="newNotificationCounter > 0">
          {{ newNotificationCounter }} {{$t('layout.notification.new')}}
        </h3>
        <p class="opacity-75">{{$t('layout.notification.app-notification')}}</p>
      </div> -->

      <VuePerfectScrollbar :key="$vs.rtl" :settings="settings"
                           class="scroll-area--nofications-dropdown p-0"
                           ref="mainSidebarPs">
        <ul class="bordered-items">
          <li :key="item.index"
            v-for="(item, index) in unreadNotifications"
            @click="onClickNotificationItem(index, item.type)"
            @mouseover="onHoverNotificationItem({ item, index })"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
              {{ item }}
              <!-- v-for="(ntf, index) in notifications"> -->
            <!-- <div class="flex items-start">
              <feather-icon :icon="getNotificationIcon(ntf.type)"
                            :svgClasses="[`text-${getNotificationColor(ntf.type)}`, 'stroke-current mr-1 h-6 w-6']">
              </feather-icon>
              <div class="mx-2">
                <span :class="[`text-${getNotificationColor(ntf.type)}`]"
                      class="font-medium block notification-title">{{ $t(ntf.name, {qty:ntf.qty}) }}</span>
                <small>{{ $t(ntf.msg) }} {{ getNotificationFromUserName(ntf.fromUser) }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.notificationAt) }}</small> -->
          </li>
        </ul>
      </VuePerfectScrollbar>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import store from '../../../../store';
import {createHelpers} from 'vuex-map-fields';
import {createNamespacedHelpers} from "vuex";
import NotificationStore from '../../../../store/modules/notification/index';

import Datastore from "@/developing/datastore";

if (!store.state.Notification) store.state.registerModule(`Notification`, NotificationStore);
const {
  mapActions: mapNotificationActions,
  mapMutations: mapNotificationMutations
} = createNamespacedHelpers(`Notification`);
const {
  mapFields: mapNotificationFields,

} = createHelpers({
  getterType: `Notification/getField`,
  mutationType: `Notification/updateField`,
});
export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      newNotificationCounterBadge: 0,
      newNotificationCounter: 0,
      unreadNotifications: [
      //   {
      //     index: 0,
      //     title: 'New Message',
      //     msg: 'Are your going to meet me tonight?',
      //     icon: 'MessageSquareIcon',
      //     time: this.randomDate({sec: 10}),
      //     category: 'primary'
      //   },
      //   {
      //     index: 1,
      //     title: 'New Order Recieved',
      //     msg: 'You got new order of goods.',
      //     icon: 'PackageIcon',
      //     time: this.randomDate({sec: 40}),
      //     category: 'success'
      //   },
      //   {
      //     index: 2,
      //     title: 'Server Limit Reached!',
      //     msg: 'Server have 99% CPU usage.',
      //     icon: 'AlertOctagonIcon',
      //     time: this.randomDate({min: 1}),
      //     category: 'danger'
      //   },
      //   {
      //     index: 3,
      //     title: 'New Mail From Peter',
      //     msg: 'Cake sesame snaps cupcake',
      //     icon: 'MailIcon',
      //     time: this.randomDate({min: 6}),
      //     category: 'primary'
      //   },
      //   {
      //     index: 4,
      //     title: 'Bruce\'s Party',
      //     msg: 'Chocolate cake oat cake tiramisu',
      //     icon: 'CalendarIcon',
      //     time: this.randomDate({hr: 2}),
      //     category: 'warning'
      //   },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed:{
    ...mapNotificationFields({
      notifications: 'notifications',
      notificationProcessing: 'processing',
      notificationError: 'error',
      notificationSuccess: 'success'
    }),
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapNotificationActions({
      getNotificationCurrentUser: 'getNotificationCurrentUser',
    }),
    ...mapNotificationMutations({
      setNotifications: 'setNotifications',
    }),
    onClickNotificationBell() {
      this.newNotificationCounter = 0;
    },
    //---------------------------------------- Page Function ------------------------------------------------------//
    onClickNotification(/* index, type */){
      // Relocate user to resource.

      // //remove clicked notification
      // const newNotifications = [
      //   ...this.notifications.slice(0, index),
      //   ...this.notifications.slice(index + 1)
      // ];
      // this.setNotifications(newNotifications);

      // let to = '#';
      // switch (type) {
      //   case 'privateMessage':
      //     to = '/pm';
      //     break;
      //   case 'webBoard':
      //     to = '/web-board/'; // + required id
      //     break;
      // }

      // if(this.$route.path !== to) {
      //   this.$router.push(to);
      // }
    },
    onHoverNotificationItem({ item }) {
      item.viewed = true;
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    getNotificationIcon(type){
      let icon = 'AlertOctagonIcon';
      switch (type) {
        case 'privateMessage':
          icon = 'MailIcon';
          break;
        case 'webBoard':
          icon = 'MessageSquareIcon';
          break;
      }
      return icon;
    },
    getNotificationColor(type){
      let color = 'danger';
      switch (type) {
        case 'privateMessage':
          color = 'primary'
          break;
        case 'webBoard':
          color = 'success'
          break;
      }
      return color;
    },
    getNotificationTime(time){
      return time
    },
    getNotificationFromUserName(fromUser){
      return `${fromUser.nameLocal} ${fromUser.surnameLocal}`
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? ` ${this.$t('general.time.years')} ` : ` ${this.$t('general.time.years')} `) + this.$t('general.time.ago')
      } else if (days > 0) {
        return days + (days > 1 ? ` ${this.$t('general.time.days')} ` : ` ${this.$t('general.time.day')} `) + this.$t('general.time.ago')
      } else if (hours > 0) {
        return hours + (hours > 1 ? ` ${this.$t('general.time.hours')} ` : ` ${this.$t('general.time.hour')} `) + this.$t('general.time.ago')
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ` ${this.$t('general.time.minutes')} ` : ` ${this.$t('general.time.minute')} `) + this.$t('general.time.ago')
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ` ${this.$t('general.time.second')} ${this.$t('general.time.ago')}` : ` ${this.$t('general.time.just-now')} `)
      }

      return this.$t('general.time.just-now')
    },
    // Method for creating dummy notification time
    randomDate({hr, min, sec}) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date
    },
    handleNotification({ signal, data }) {
      // console.log("handleNotification", signal, data);
      const previousNotificationIndex = this.findAndRemovePreviousDuplicateNotification(data.fromUserCode);
      const previousNotification = this.unreadNotifications[previousNotificationIndex];
      // console.log("previousNotification", previousNotification);

      this.storeNotificationToFlatmap(data)

      if (!previousNotification || previousNotification.viewed === true) {
        this.newNotificationCounter += 1;
      }
      this.unreadNotifications.splice(previousNotificationIndex, 1);

      switch (signal) {
        case "pm-reply":
          // Check for existed message send from same signal and person then replace it with the new one (reorder also)
          this.unreadNotifications.unshift(this.setNotificationMessageForPM(data));
          break;
        default:
          break;
      }
    },
    storeNotificationToFlatmap(data) {
      Datastore.Notification.save(data.type, data.channel, data.id, data);
    },
    findAndRemovePreviousDuplicateNotification(fromUserCode) {
      // Find previous message index
      const prevIndex = this.unreadNotifications.findIndex(item => item.fromUserCode === fromUserCode);

      if (prevIndex === -1) {
        return null;
      }
      return prevIndex;
    },
    setNotificationMessageForPM(data) {
      // console.log("createNotificationMessageForPM", data);

      return {
        title: `${data.fromUserCode} ได้ส่งข้อความถึงคุณ`,
        channel: "pm",
        icon: 'ChatIcon',
        time: `${data.sendDate}`,
        category: 'danger',
        viewed: false,
        fromUserCode: data.fromUserCode,
        timestamp: new Date(data.sendDate).getTime()
      }
    }
  },
  async created() {
    this.$context.eventbus.$on("notify", this.handleNotification);

    this.unreadNotifications = Array.from(Datastore.Notification.data.values());
    // console.log(this.unreadNotifications);
  },
  async beforeMount() {
    await this.getNotificationCurrentUser();
  }
}
</script>

<style lang="scss">
.notification-bell {

  & .feather-icon-badge {
    background: rgba(var(--vs-danger), 1) !important;
  }
}

.notification-dropdown {
  & .vs-dropdown--menu--after {
    background: white !important;
  }
}
</style>
